export default class checkAllInputs {
    constructor() {
      this.checkAll()
    }
  
    private checkAll() {
        const checkAllInput = document.querySelector('#reg_marketing') as HTMLElement
        const inputs = document.querySelectorAll<HTMLInputElement>('.fields-group input')

        if (checkAllInput && inputs.length > 0) {
            checkAllInput.addEventListener('click', () => {
                inputs.forEach(input => {
                    input.checked = true
                });
            })
        }
    }
}
  